import React, { useEffect, useState, useRef } from "react";
import classes from "./Notifications.module.css";
import Container from "../../UI/Container/Container";
import NotificationDiv from "./NotificationDiv/NotificationDiv";
import Cookies from "js-cookie";
import axios from "axios";

import ToasterUpdate from "../Toaster/ToasterUpdate";
import { toast } from "react-toastify";
import NotificationModal from "../NotificationModal/NotificationModal";
import { BASE_URL } from "../../Apis/BaseUrl";

const Notifications = ({ setterFunc, onNotificationUpdate }) => {
  const [notificationData, setNotificationData] = useState([]);
  const [open, setOpen] = useState(false);
  const [myData, setMyData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isMountedRef = useRef(true);
  const toggleOpen = () => setOpen(!open);

  const handleModal = (data) => {
    setMyData(data);
    setOpen(!open);
    console.log("modal opened", data);
  };

  let profileTokenJson = Cookies.get("v&b_token");
  let profileToken = JSON.parse(profileTokenJson);
  let token = profileToken.token;
  console.log(profileToken);

  const getNotification = async () => {
    try {
      setError(null);
      let register = `${BASE_URL}/notification?limit=20&page=1`;

      let res = await axios.get(register, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      // Only update state if component is still mounted
      if (!isMountedRef.current) return;

      console.log(res.data, "Notification data received");

      // Validate response structure
      if (res.data && res.data.data && res.data.data.docs) {
        setNotificationData(res.data.data.docs || []);
      } else {
        console.error('Unexpected API response structure:', res.data);
        setNotificationData([]);
      }
    } catch (error) {
      // Only update state if component is still mounted
      if (!isMountedRef.current) return;

      console.error('Error fetching notifications:', error);
      setError('Failed to load notifications');
      setNotificationData([]);
      toast.error('Failed to load notifications');
    }
  };

  const markAsRead = async () => {
    const register = `${BASE_URL}/notification/seen`;
    const myToast = toast.loading("Please Wait...");
    setLoading(true);
    try {
      let res = await axios.put(
        register,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await getNotification();

      // Notify parent to refresh count
      if (onNotificationUpdate) {
        onNotificationUpdate();
      }

      // Use the message from response or a default message
      const message = res.data?.message || "All notifications marked as read";
      ToasterUpdate(myToast, message, "success");
    } catch (error) {
      console.error('Error marking notifications as read:', error);
      const errorMessage = error.response?.data?.message || error.message || "Failed to mark notifications as read";
      ToasterUpdate(myToast, errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    isMountedRef.current = true;
    getNotification();

    // Cleanup on unmount
    return () => {
      isMountedRef.current = false;
    };
    // eslint-disable-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {open && <NotificationModal data={myData} show={open} handleModal={handleModal} handleClose={toggleOpen} />}
      <div onClick={() => setterFunc(false)} className={classes.overlay}></div>
      <Container cls={classes.box}>
        <div className={classes.header}>
          <div className={classes.headerContent}>
            <span>All Notifications</span>
          </div>
        </div>

        {error && (
          <div className={classes.errorMessage}>
            {error}
            <button onClick={() => getNotification()} className={classes.retryBtn}>
              Retry
            </button>
          </div>
        )}

        {notificationData?.length !== 0 ? (
          <div className={classes.body}>
            {notificationData?.map((element, index) => (
              <NotificationDiv
                key={element._id}
                {...element}
                refreshFunc={() => {
                  getNotification();
                  if (onNotificationUpdate) {
                    onNotificationUpdate();
                  }
                }}
                parentFunc={setterFunc}
                index={index}
              />
            ))}
            <button className={classes.markasread} onClick={markAsRead} disabled={loading}>
              {loading ? 'Marking...' : 'Mark All as Read'}
            </button>
          </div>
        ) : (
            <div className={classes.noNotifications}>
              No notifications
            </div>
        )}
      </Container>
    </>
  );
};

export default Notifications;
